<template>
  <div class="as-dropdown-toggle" v-if="dataFilterAll">
    <div class="as-dropdown-toggle__select">
      <div class="as-dropdown-toggle__select__as-head" @click="handleToggle" ref="selectHeader">
        <img v-if="iconField && itemActive" :src="getImgUrlBySport(iconField, itemActive.id)" :alt="getName(itemActive)" />
        <span>{{
          itemActive && itemActive?.id
            ? getName(itemActive)
            : "Tất cả"
        }}</span>
        <IconCustomArrownDown
          v-if="!isShow"
          fill="#2FB925"
          @click.stop="handleToggle"
        />
        <IconCustomArrownUp fill="#2FB925" v-else @click.stop="handleToggle" />
      </div>
      <div v-if="isShow" class="as-dropdown-toggle__select__as-body" ref="selectContent">
        <div v-if="isSearchAll" class="as-dropdown-toggle__select__as-body__search">
          <input name="search" placeholder="Tìm kiếm..." @input="handleSearch" :value="searchQuery" />
        </div>
        <div
          v-if="!!dataFilterAll?.length"
          v-for="(item, index) in dataFilterAll"
          :key="index"
          class="as-item-dropdown"
          :class="{
            'as-active': idActive === item.id
          }"
          @click="handleChoose(item)"
        >
          <img v-if="iconField" :src="getImgUrlBySport(iconField, item.id)" :alt="getName(item)" />
          <span>{{ getName(item) }}</span>
        </div>
        <div v-else>
          <Loading v-if="isSearchAll && searchLoading" iconOnly />
          <NoData v-else title="Không tìm thấy dữ liệu" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, defineEmits } from "vue";
import { useClickOutside } from "~src/utils/clickOutsideHelper";
import IconCustomArrownDown from "~src/components/icons/IconCustomArrownDown.vue";
import IconCustomArrownUp from "~src/components/icons/IconCustomArrownUp.vue";
import Loading from "./Loading.vue";
import NoData from "./NoData.vue";

const emits = defineEmits(["handleChoose", "handleSearch"]);

interface IProps {
  data: any[];
  idActive?: string | number;
  isFilterAll?: boolean;
  isSearchAll?: boolean;
  iconField?: string;
  searchQuery?: string;
  searchLoading?: boolean
}
interface Item {
  id: number | string;
  title?: string;
  name?: string;
  year?: string;
}
const props = withDefaults(defineProps<IProps>(), {});
const selectHeader = ref<HTMLElement | null>(null);
const selectContent = ref<HTMLElement | null>(null);
const itemActive = ref<Item | null>(
  props.idActive
    ? props.data.find((item: any) => item.id === props.idActive)
    : null
);
const isShow = ref(false);

const dataFilterAll = computed(() => {
  if (props.isFilterAll) {
    return [{ id: "", name: "Tất cả" }, ...props.data];
  }

  return props.data;
});

const handleToggle = () => {
  isShow.value = !isShow.value;
};
const handleChoose = (item: Item) => {
  itemActive.value = item;
  isShow.value = false;

  emits("handleChoose", item);
};

const handleSearch = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const value = target.value;

  emits("handleSearch", value);
};

const closeCountrySelect = () => {
  isShow.value = false;
};

const getName = (item: Item) => {
  return item.name ?? item.year ?? item.title;
};

useClickOutside([selectHeader, selectContent], {
  handler: closeCountrySelect,
  middleware: (event) => {
    const target = event.target as HTMLElement;

    if (target.closest(".icon-arrow")) {
      return false;
    }

    return true;
  },
});
</script>

<script lang="ts">
export default {};
</script>

